import PropTypes from "prop-types"
import React from "react"

const Input = ({
  type,
  placeholder,
  name,
  id,
  additionalClassName = "",
  onChange,
  value,
}) => {
  const types = ["text", "number", "checkbox", "email", "telephone"]

  return (
    <input
      type={types[type]}
      id={id}
      name={name}
      placeholder={placeholder}
      className={`w-full rounded-lg font-inter text-sm text-gray-900 placeholder-gray-900 px-3 py-2 border-none focus:outline-none ring-1 ring-brand-deepblack focus:ring-brand-blue ${additionalClassName} appearance-none`}
      onChange={onChange}
      value={value}
    />
  )
}

Input.propTypes = {
  type: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  additionalClassName: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
}

export default Input
